import React, { useState, useCallback, useMemo } from "react";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../../nodeInstance";
import { FaFilePdf } from "react-icons/fa";
import DocumentUploadFilePopUp_Muqeem from "../FileDocumentPopUp/fileUploadMuqeem";
import DocumentsDownloadPopup from "../IqamaRenewList/popups/DocumentsDownloadPopup";
import SmartDownloadPagination from "../../../../../components/SmartDataTable/SmartDownloadPagination";

export default function ListMuqeemDocumentPendinglist({
  setTrigger: parentSetTrigger,
  trigger: parentTrigger,
  setData
}) {
  const [Popup, setPopUp] = useState(false);
  const [documentPopUp, setDocumentPopUp] = useState(false);
  const [document, setdocument] = useState([]);
  const [empData, setEmpData] = useState({});
  const [trigger, setLocalTrigger] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchData, setSearchData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const token = localStorage.getItem("nodeToken");
  const dispatch = useDispatch();

  const columns = useMemo(() => [
    { key: "sno", title: "S.NO." },
    { key: "emp_id", title: "EMPLOYEE ID" },
    { key: "border_number", title: "BORDER NUMBER" },
    { key: "visa_provider", title: "VISA PROVIDER" },
    { key: "sponsor_id", title: "SPONSOR ID" },
    { key: "client", title: "CLIENT" },
    { key: "iqama_number", title: "IQAMA NUMBER" },
    { key: "iqama_received_date", title: "IQAMA RECEIVED DATE" },
    { key: "iqama_issue_date", title: "IQAMA ISSUE DATE" },
    { key: "iqama_expiry_date_g", title: "IQAMA EXPIRY DATE (G)" },
    { key: "iqama_expiry_date_h", title: "IQAMA EXPIRY DATE (H)" },
    { key: "iqama_aging_days", title: "IQAMA AGEING DAYS" },
    { key: "iqama_valid_days", title: "IQAMA VALID DAYS" },
    { key: "iqama_status", title: "STATUS" },
    { key: "action", title: "ACTION" },
  ], []);

  const handleStandaloneSearch = async (term) => {
    if (!term) return;
    setIsLoading(true);
    setIsSearchActive(true);
    try {
      const response = await nodeinstance.get(
        `/iqama/iqammaDoneSearchMuqeem/Muqeem/${term}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data) {
        setSearchData(response.data.data || []);
      }
    } catch (error) {
      dispatch(setAppError({ msg: "Search failed: " + error.message }));
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (value) => {
    if (!value) {
      setIsSearchActive(false);
      setSearchData(null);
    }
  };

  const downloadDocumentPopUp = (listDocument, row) => {
    setdocument(listDocument);
    setEmpData(row);
    setDocumentPopUp(true);
  };

  const renderCustomCell = (item, column) => {
    if (column.key === "iqama_status") {
      return item.iqama_status_value?.toString() === "2"
        ? "Muqeem Document Pending"
        : item.iqama_status || "-";
    }
    if (column.key === "action") {
      if (!item.documents || item.documents.length === 0) return "-";
      return (
        <button
          className="p-1"
          onClick={() => downloadDocumentPopUp(item.documents, item)}
        >
          <FaFilePdf size={"1.4rem"} color="red" />
        </button>
      );
    }
    return null;
  };

  const additionalActions = useMemo(() => [
    {
      label: "Upload File",
      onClick: () => setPopUp(true),
      className: "p-2 px-4 rounded-md bg-blue text-white text-sm"
    }
  ], []);

  const setTrigger = () => {
    setLocalTrigger(prev => !prev);
    if (parentSetTrigger) parentSetTrigger(prev => !prev);
  };

  return (
    <>
      <div className="mt-4">
        <SmartDownloadPagination
          apiEndpoint="/iqama/iqammaDone/Muqeem"
          token={token}
          columns={columns}
          layoutType="table"
          additionalActions={additionalActions}
          renderCustomCell={renderCustomCell}
          searchPlaceholder={"Search employee id..."}
          defaultPageSize={50}
          pageSizeOptions={[10, 50, 100, 500, 1000]}
          trigger={trigger || parentTrigger}
          onSearchClick={handleStandaloneSearch}
          onSearchChange={handleSearchChange}
          manualData={isSearchActive ? searchData : null}
          enableDownload={false}
        />
      </div>

      {Popup && (
        <DocumentUploadFilePopUp_Muqeem
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"Bulk Upload Muqeem Documents"}
          url={`/iqama/bulkuploadMuqeemDoc/`}
          fileFormat={">  muqeem-profile-IQAMA NUMBER"}
          fileNme={"Muqeem-profile-Iqama Number"}
          setTrigger={setTrigger}
          trigger={trigger}
          setData={setData}
        />
      )}

      {documentPopUp && (
        <DocumentsDownloadPopup
          empData={empData}
          PopUp={documentPopUp}
          setPopUp={setDocumentPopUp}
          title={"Upload Border Number"}
          url={"/iqama/updatestatus"}
          list={document}
          setData={setData}
        />
      )}
    </>
  );
}
